<!-- 头部 -->
<template>
    <div class="waper">
        <!-- 头部左侧 -->
        <div class="header-left-container">
            <div class="system-title-container">
                <img src='@/assets/image/home/logo.png'/>
                <span class="system-title">重庆市住房和城乡建设委员会</span>
                <span class="splite-line"></span>
                <span class="system-title">重庆市配套费管理系统</span>
            </div>
        </div>
        <!-- 头部右侧 -->
        <div class="header-right-container">
            <div class="userinfo-box">
                <img :src='photoSrc'/>
                <span>{{user.name}}</span>
            </div>

            <div class="login-out">
                <img src='@/assets/image/home/login-out.png'/>
                <span @click="skip2">退出</span>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import axios from "../../utils/axios";
export default {
    name:'header',
    data() {
        return {
            dropMenuVisiable : false,
            photoSrc : require('@/assets/image/home/default-photo.png')
        }
    },
    computed:{
        ...mapGetters({
            user: 'getUser',
        })
    },
    mounted(){
    },
    methods:{
      skip2(){
        axios.get('/base/login/loginOut');

        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          localStorage.removeItem('key')
        }
        for (let i = 0; i < sessionStorage.length; i++) {
          const key = sessionStorage.key(i);
          sessionStorage.removeItem('key');
        }
        this.$router.push('/login');
    }
  }
}
</script>
<style scoped>
    .waper{
        width:100%;
        height:100%;
    }
    .header-left-container,.header-right-container{
        width:50%;
        height:100%;
    }

    .header-left-container{
        float: left;
        display:flex;
        align-items: center;
    }

    .system-title-container{
        display: flex;
        align-items: center;
        line-height: 2.5rem;
        font-size: 1.8rem;
    }

    .system-title-container img{
        padding-right: 1rem;
    }

    /* .system-title-container .system-title{
    } */

    .system-title-container .splite-line{
        height: 2.5rem;
        border-left: 1px solid #FFF;
        margin: 0 1.6rem;
    }

    .menu-drop-container{
        width:18rem;
        height:4rem;
        margin-left : 4.5rem;
        display: flex;
        align-items: center;
        font-size: 1.8rem;
        position: relative;
    }

    .menu-drop-container .menu-drop-title{
        width:16rem;
        line-height: 4rem;
        padding: 0 1rem;
        border: 1px solid rgba(0,0,0,0.20);
        border-radius: 2px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor:pointer;
        position: absolute;
    }

    .menu-drop-container .menu-drop-title i{
        margin-top: 1.2rem;
        font-size: 1.2rem;
    }

    .menu-drop-container .menu-drop-title.is-drop i{
        margin-top: -1.2rem;
    }

    .menu-drop-item-box{
        width:16.2rem;
        max-height: 27rem;
        padding: 0.5rem 1rem;
        display: flex;
        flex-direction: column;
        position: absolute;
        top:4.1rem;
        z-index: 99;
        background: #2372EA;
        border-radius: 5px;
    }

    .menu-drop-item-box .menu-drop-item{
        color: rgba(255,255,255,0.65);
        padding:1.1rem 0 ;
        font-size: 1.4rem;
        border-bottom: 1.5px solid rgba(255,255,255,0.45);
        box-shadow: 0 1px 2px 0 rgba(0,0,0,0.05);
        cursor: pointer;
    }

    .menu-drop-item-box .menu-drop-item:hover{
        color: rgba(255,255,255);
    }

    .menu-drop-item-box .menu-drop-item:last-child{
        border-bottom:none
    }

    /* .my-drop-enter-active{

    } */

    .header-right-container{
        width:auto;
        float: right;
        display:flex;
        align-items: center;
    }

    .userinfo-box{
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .userinfo-box img{
        width:2.4rem;
        height: 2.4rem;
    }

    .userinfo-box span{
        font-size: 1.4rem;
        padding: 0 1rem;
    }

    .login-out{
        display: flex;
        align-items: center;
        margin-left: 2rem;
        cursor: pointer;
    }

    .login-out img{
        width:2.4rem;
        height: 2.4rem;
    }

    .login-out span{
        font-size: 1.4rem;
        padding: 0 1rem;
    }
</style>





// WEBPACK FOOTER //
// src/views/common/header.vue